import { StorageService } from '~/common/utils/storage';
import { CookieService } from '~/common/utils/cookies';
import { LOCAL_STORAGE_KEYS } from '~/common/constants/localStorage';

// The "already signed up" flag: read by the homepage pop-up, written by every
// sign-up surface. Reader and writer live together so the consent gate below has one
// definition.
//
// Its own module rather than exports on `useNewsletterSubscribe`, where these used
// to live: that hook imports yup, so consumers of the flag inherited ~42KB through a
// three-line localStorage setter. KEEP THIS FILE FREE OF YUP and of anything that
// reaches it — the regression is invisible outside the chunk graph.

export const hasUserSubscribedToNewsletter = (): boolean =>
  !!StorageService.getItem(LOCAL_STORAGE_KEYS.newsletterSubscribed);

/**
 * Suppresses the homepage pop-up for someone who has already signed up. The cookie
 * policy classifies that as a functionality item, hence the consent check.
 */
export const markUserSubscribedToNewsletter = (): void => {
  if (!CookieService.hasFunctionalityConsent()) return;

  StorageService.setItem(LOCAL_STORAGE_KEYS.newsletterSubscribed, true);
};
